import PropTypes from "prop-types";

import AppcuesTrackingContainer from "@/appcues/AppCuesTrackingContainer";
import PageViewTrigger from "@/base/PageViewTrigger";
import useAddCustomHeapAttributes from "@/base/utils/useAddCustomHeapAttributes";
import HeapTrackingContainer from "@/heapIntegration/HeapTrackingContainer";
import BrowserLogging from "@/datadog/BrowserLogging";
import RUMTracking from "@/datadog/RUMTracking";
import GlobalEventsHandler from "./GlobalEventsHandler";

/**
 * Creates a wrapper which is meant to be rendered before every "page" of the application.
 * Elements should if possible be rendered as siblings to avoid potentially unnecessary rerenders of the children element
 * @param {node} children - Wrapped pages.
 */

const AllPagesWrapper = ({ children }) => {
  // Add any custom Heap attributes needed that can be derived from user attributes
  // or membership to other objects.
  useAddCustomHeapAttributes();

  return (
    <>
      <RUMTracking />
      <BrowserLogging />
      <GlobalEventsHandler />
      <PageViewTrigger />
      <AppcuesTrackingContainer />
      <HeapTrackingContainer />
      {children}
    </>
  );
};

AllPagesWrapper.propTypes = {
  children: PropTypes.node,
};

export default AllPagesWrapper;
